// @flow
import React from "react";
import styled from "styled-components";
import { renderRoutes } from "react-router-config";

import Footer from "../../components/Footer/Footer";
import Navigation from "./Navigation/Navigation";
import ProgressBar from "./ProgressBar";

const PageBackground = styled.main`
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  background-color: white;
  position: relative;
  box-shadow: 0 0 4px 0 rgba(34, 34, 34, 0.1);
  flex-grow: 1;
`;

const Content = styled.div`
  min-height: 500px;
`;

type Props = RouteProps<{}>;

const MarketingLayout = ({ route: { routes } }: Props) => (
  <PageBackground>
    <ProgressBar />
    <Navigation />
    <Content>{renderRoutes(routes)}</Content>
    <Footer />
  </PageBackground>
);

export default MarketingLayout;
